<div class="max-w-comfort">
  <p-card>
    <div class="mx-6 my-4">
      <app-patient-info-input title='Pre-Myopic' [name]="patientName"
        [ageAtVisit]="calculationResults.serCalcResponse.ethnicities[0].decimalAge" [dateOfLastVisit]="calculationResults.serCalcResponse.ethnicities[0].dateAtLastVisit"></app-patient-info-input>
      @if (reportType === ReportType.ECP && calculationResults.ageWarning) {
      <div class="mb-4">⚠️ {{ 'AGE_WARNING' | translate }}</div>
      }
      <app-population-comparison class="mt-6" [serCalcResponse]="calculationResults.serCalcResponse"
        [axialCalcResponse]="calculationResults.axialCalcResponse"
        [treatmentCalcResponse]="calculationResults.treatmentCalcResponse" [ethnicity]="currentEthnicity"
        (ethnicityChanged)="onEthnicityChange($event)"></app-population-comparison>

      @if (calculationResults.standardProgressionReponse.leftEyeResults ||
      calculationResults.standardProgressionReponse.rightEyeResults) {
      <app-standard-progression [ethnicity]="currentEthnicity" (ethnicityChanged)="onEthnicityChange($event)"
        [ageAtProgression]="calculationResults.standardProgressionReponse.ageAtProgression"
        [mostMyopicEyeSide]="calculationResults.serCalcResponse.mostMyopicEye ?? calculationResults.axialCalcResponse.mostMyopicEye"
        [leftEyeProgressionStat]="calculationResults.standardProgressionReponse.leftEyeResults"
        [rightEyeProgressionStat]="calculationResults.standardProgressionReponse.rightEyeResults"></app-standard-progression>
      } @if(calculationResults.treatmentCalcResponse.treatmentItems.length > 0) {
      <app-myopia-treatments [treatmentCalcResponse]="calculationResults.treatmentCalcResponse"></app-myopia-treatments>
      }
      <app-credits class="w-full"></app-credits>

    </div>
  </p-card>
</div>
<div class="max-w-comfort"></div>